import React, {
	Component,
} from 'react';



class HeaderOptionsLayout extends Component {

	render() {
		const {
			children,
		} = this.props;

		return (
			<div className="header-options-layout">
				{children}
			</div>
		);
	}

}



export default HeaderOptionsLayout;
